export const toPluralOrSingular = (wordInSingular: string, count: number | undefined) => {
  if (count === 1) return wordInSingular;
  return `${wordInSingular}s`;
};
